export const getters = {
    cidadao: (state) => state.cidadao
};
